import ResultRow from "../../components/table/ResultRow";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import {InputNumber, Select} from "antd";


export default function getSettingsItem({value, onChange, defaultValue, label, description, min, max, step, precision, disabled}) {
    return (
        <ResultRow>
            <ResultBodyCell style={{textAlign: 'start'}}>
                {label}
            </ResultBodyCell>
            <ResultBodyCell style={{padding:0}}>
                <InputNumber
                    style={{width: 115, margin: 0}}
                    controls={false}
                    value={value ?? defaultValue}
                    onChange={onChange}
                    min={min}
                    max={max}
                    step={step ?? 0.01}
                    precision={precision ?? 2}
                    disabled={disabled}
                />
            </ResultBodyCell>
            <ResultBodyCell style={{textAlign: 'center'}}>
                <div style={{fontStyle: 'italic', color: '#00000088', textAlign: 'left', marginLeft: 4}}>
                    {defaultValue === 0 ? '0.00' : defaultValue}
                </div>
            </ResultBodyCell>
            <ResultBodyCell>
                {description}
            </ResultBodyCell>
        </ResultRow>
    )
}


export function getSettingsSelectItem({value, onChange, defaultValue, label, description, min, max, options}) {
    return (
        <ResultRow>
            <ResultBodyCell style={{textAlign: 'start'}}>
                {label}
            </ResultBodyCell>
            <ResultBodyCell style={{padding:0}}>
                <Select
                    size={'small'}
                    style={{width: 115, margin: 0}}
                    value={value}
                    onChange={onChange}
                >
                    {options}
                </Select>
            </ResultBodyCell>
            <ResultBodyCell style={{textAlign: 'center'}}>
                <div style={{fontStyle: 'italic', color: '#00000088', textAlign: 'left', marginLeft: 4}}>
                    {defaultValue}
                </div>
            </ResultBodyCell>
            <ResultBodyCell>
                {description}
            </ResultBodyCell>
        </ResultRow>
    )
}